import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import {
  PunchCardProductType,
  PunchCardType,
} from "../../../service/api-response/PunchCards";
import { SelectProductsSelector } from "../../../components/SelectProductsSelector";

export const ProductsInPack = () => {
  const { control, getValues, watch } = useFormContext<PunchCardType>();

  const { replace, fields, remove } = useFieldArray({
    control,
    name: "products",
  });

  return (
    <>
      <div className="form-group">
        <label className="form-label">Products</label>
        <ul className="container">
          <li className="row">
            <div className="col-3">
              <b>Name</b>
            </div>
            <div className="col-3">
              <b>Amount</b>
            </div>
          </li>
          {fields.map((field, index) => (
            <li
              key={field.id}
              className="row pt-4"
              style={{ alignItems: "center" }}
            >
              <Controller
                defaultValue={field.id}
                name={`products[${index}].id` as any}
                render={() => <></>}
              />
              <div className="col-3">{field.name}</div>
              <Controller
                name={`products[${index}].amount` as any}
                defaultValue={field.amount}
                render={({ field: { value, onChange } }) => {
                  return (
                    <div className="col-3">
                      <input value={value} onChange={onChange} />
                    </div>
                  );
                }}
              />
              <div className="col-3">
                <button
                  className="btn btn-sm btn-outline-warning"
                  onClick={() => remove(index)}
                >
                  Remove
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <SelectProductsSelector
        filters={{ classification: "voucher_type" }}
        productIdsToLeaveOut={(watch("products") || []).map((x: any) => x.id)}
        buttonText="Add vouchers"
        modalHeader="Add vouchers"
        onSave={(products) => {
          const currentProducts = getValues("products");
          const productsToAdd: PunchCardProductType[] = products.map((p) => ({
            id: p.id,
            name: p.name,
            title: p.name,
            amount: 1,
          }));
          replace([...currentProducts, ...productsToAdd]);
        }}
      />
    </>
  );
};
